import styled from 'styled-components';
import { appConfig } from '../../../../configureApp';

const TrawickTextInput = styled.input`
  color: #464444;
  width: 100%;
  height: 58px;
  box-shadow: none;
  position: relative;
  font-size: 16px;
  margin: 0;
  line-height: 24px;
  padding: 15px 20px;
  border: 2px solid #e1e1e1;
  // border-radius: 10px;
  background: #f3f3f3;
  &:focus {
    outline: none;
  }
`;

const SCTITextInput = styled.input`
  color: #4A4A4A;
  font-family: 'Omnes';
  font-size: 16px;
  font-weight: 500; /* Medium weight */
  width: 100%;
  height: 58px;
  box-shadow: none;
  position: relative;
  margin: 0;
  line-height: 24px;
  padding: 15px 20px;
  border: 2px solid #D1D1D1;
  border-radius: 8px;
  background: #FFFFFF;

  &::placeholder {
    color: #4A4A4A;
    font-family: 'Omnes';
    font-size: 16px;
    font-weight: 500; /* Medium */
  }

  &:focus {
    outline: none;
    border-color: #4A90E2;
  }
`;

const TextInput = appConfig.reactAppEnv === 'scti' ? SCTITextInput : TrawickTextInput;
export default TextInput;



// WEBPACK FOOTER //
// ./app/containers/Login/components/TextInput/index.js